import React from "react";
import { Box } from "@mui/material";

export const RegoAIConnectTooltipTitle = () => (
  <span>
    By connecting this, you allow Rego AI to collect evidence on your behalf
    and surface it for review.{" "}
    <Box
      component="a"
      href="/admin/regoai"
      target="_blank"
      rel="noopener"
      onClick={(e) => e.stopPropagation()}
      sx={{
        color: "inherit",
        textDecoration: "underline",
        cursor: "pointer",
      }}
    >
      How Rego AI works
    </Box>
  </span>
);
